import axios from "axios";
import {
    URLAPI,
    ZONE_PATH,
    ZONE_CREATE_PATH,
    ZONE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'

const init = {
    _get_all_zones: {
        data: [],
        status: 0,
        message: {},
    },
    _create_zones: {
        data: {},
        status: 0,
        message: {},
    },
    _update_zones: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_ZONES_SUCCESS = "GET_ALL_ZONES_SUCCESS";
export const CREATE_ZONES_SUCCESS = "CREATE_ZONES_SUCCESS";
export const UPDATE_ZONES_SUCCESS = "UPDATE_ZONES_SUCCESS";

export const zone_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_ZONES_SUCCESS:
            return {
                ...state,
                _get_all_zones: action.payload,
            };
        case CREATE_ZONES_SUCCESS:
            return {
                ...state,
                _create_zones: action.payload,
            };
        case UPDATE_ZONES_SUCCESS:
            return {
                ...state,
                _update_zones: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const get_all_zones = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ZONE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_ZONES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const create_zones = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${ZONE_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_ZONES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: CREATE_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const update_zones = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${ZONE_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_ZONES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ZONES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const clear_zone = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
